import { getApiUrl } from '../helper/getApiUrl';

const apiUrl = getApiUrl();

export interface PaymentFormInitSuccessResult {
    status: 'success';
    publishableKey: string;
    externalAccountId?: string;
}

export interface PaymentFormInitErrorResult {
    status: 'stripe-setup-incomplete';
}

export type PaymentFormInitResult = PaymentFormInitSuccessResult | PaymentFormInitErrorResult;

const init = async (paymentConfigId: string): Promise<PaymentFormInitResult> => {
    const response = await fetch(`${apiUrl}/payment-form/${paymentConfigId}`);

    if (response.status === 404 || response.status === 400) {
        return {
            status: 'stripe-setup-incomplete',
        };
    }

    const json = await response.json();

    if (json.success) {
        return {
            status: 'success',
            ...json.data,
        };
    }

    throw new Error(json.errors[0]);
};

export interface CreatePaymentIntentOptions {
    paymentConfigId: string;
    perspectiveSessionId: string;
    globalId: string;
}

const createPaymentIntent = async ({
    paymentConfigId,
    perspectiveSessionId,
    globalId,
}: CreatePaymentIntentOptions): Promise<string> => {
    const response = await fetch(`${apiUrl}/payment-intent`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            paymentConfig: {
                id: paymentConfigId,
            },
            session: {
                id: perspectiveSessionId,
            },
            device: {
                id: globalId,
            },
        }),
    });
    const json = await response.json();

    if (json.success) {
        return json.data.clientSecret;
    }

    throw new Error(json.errors[0]);
};

export const paymentsApi = {
    paymentForm: {
        init: init,
    },
    paymentIntent: {
        create: createPaymentIntent,
    },
    s3: {
        createSignedUrl: async (args: {
            companyId: string;
            campaignId: string;
            fileName: string;
            mimeType: string;
            size: number;
            checksum: string;
        }): Promise<{ uploadId: string; uploadUrl: string } | string> => {
            const response = await fetch(`${apiUrl}/uploads/start`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(args),
            });

            if (response.status === 404) {
                throw new Error('File type not supported');
            }

            const json = await response.json();

            if (json.success) {
                return {
                    uploadId: json.data.uploadId,
                    uploadUrl: json.data.uploadUrl,
                };
            }

            throw new Error(json.errors[0]);
        },
    },
};
